<template>
  <Card variant="outline" size="medium">
    <template #header>
      <Text variant="h4">Residence</Text>
      <slot name="actions" />
    </template>

    <div class="details" v-if="residenceInfo.length">
      <ResidenceInfoItem v-for="info in residenceInfo" :key="info.id" :residence-info="info" />
    </div>

    <Text v-else variant="body-medium">No info</Text>
  </Card>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { Card, Text } from '@tallo/design-system';

import { ApplicationResidenceInfoDto, ApplicationResidenceInfoType } from '../../interfaces/residence-info.interface';
import ResidenceInfoItem from './residence-info-item.vue';

const props = defineProps<{ residenceInfo: ApplicationResidenceInfoDto[] }>();

const residenceInfo = computed(() =>
  [...props.residenceInfo].sort((a) => (a.type === ApplicationResidenceInfoType.CURRENT ? -1 : 1)),
);
</script>

<style scoped lang="scss">
@import 'styles/mixins/layout.mixins';

.details {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--t-spacing-md);

  @include mobile {
    grid-template-columns: 1fr;
  }
}
</style>
